import React, { useState, useEffect } from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export default function JobSkeleton({ width = null }) {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const getSkeletonWidth = () => {
    if (screenWidth > 768) return "300px";
    return "70vw";
  };

  return (
    <div
      className="d-flex flex-column align-items-center justify-content-center gap-4 p-3"
      style={{ alignItems: "center", maxWidth: width ? width : "auto" }}
    >
      {[...Array(3)].map((_, index) => (
        <div
          key={index}
          style={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Skeleton
            width={getSkeletonWidth()}
            height="25vh"
            baseColor="#ddd"
            highlightColor="#f5deb3"
            style={{ marginTop: "1vh" }}
          />
        </div>
      ))}
    </div>
  );
}
